import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Trash from '../../assets/trash.svg'

import { Container, Title, Table } from './styles'

export function TemNoParqueGalerias() {
 const title = 'Tem no Parque'
 const subtitle = 'Lista de Galerias'

 const fields = useMemo(
  () => [
   {
    id: 'Lista de Galerias',
    p_id: String,
    titleGallery: String,
    gallery: Array,
    videosTitle: String,
    videos: String
   }
  ],
  []
 )

 const {
  galerias,
  setGalerias,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(galerias.length / limit)

 const loadGalerias = useCallback(async () => {
  try {
   const response = await api.get('temnoparque-galerias')

   setGalerias(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar as galerias')
  }
 }, [setGalerias])

 useEffect(() => {
  loadGalerias()
 }, [loadGalerias])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadGalerias}
     fields={fields}
     name="temnoparque-galerias"
     title="Galeria"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadGalerias}
     id={id}
     name="temnoparque-galerias"
     title="Galeria"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadGalerias}
     id={id}
     name="temnoparque-galerias"
     folder="temnoparquegalerias"
     title="Galeria"
    />
   )}

   <Header title={title} subtitle={subtitle} />
   <Container>
    <Title>Gerenciador de galerias</Title>
    {galerias.length <= 0 ? (
     <>Nenhuma galeria cadastrada.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <th>Exibição</th>
         <th>Título da Galeria de imagens</th>
         <th>Título da Galeria de vídeo</th>
         <th>Vídeos</th>
         <th colSpan="2"></th>
        </tr>
       </thead>
       <tbody>
        {galerias &&
         galerias.slice(offset, offset + limit).map(galeria => (
          <tr key={galeria.id}>
           <td>{galeria.id}</td>
           <td>{galeria.titleGallery}</td>
           <td>{galeria.videosTitle}</td>
           <td>{galeria.videos}</td>
           <td onMouseDown={() => setID(galeria.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(galeria.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
